<template>
  <div class="networking" id="networking">
    <iframe
      class="networking__iframe"
      :src="link"
      frameborder="0"
      allow="camera; microphone"
      allowTransparency="false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Networking',
  props: {
    roomData: Object
  },
  computed: {
    ...mapGetters({
      usersName: 'current_user/fullName',
      usersAvatar: 'current_user/avatar'
    }),
    link() {
      return this.roomData.joinLink.split('?')[0]
    },
  },
  methods: {
    ...mapActions(['handleLeaveRoom']),
    receiveMessage (event) {
      if(event.data == 'leaveRoom') this.handleLeaveRoom();
    }
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage)
  }
};
</script>

<style lang="scss" scoped>
.networking {
  background: white;
  width: 100%;
  height: 100%;

  &__iframe {
    height: 100%;
    width: 100%;
    border: none;
  }
}
</style>
